import { createAsyncThunk } from '@reduxjs/toolkit';
import { CommunicationActions } from './CommunicationSlice';
import { CommunicationListResponseType } from 'src/shared/types/src';
import { fetchCommunication } from 'src/shared/services/src';

export const updateCommunicationLoader = createAsyncThunk(
  'updateCommunicationLoader',
  async (payload: { communicationLoading: boolean }, { dispatch }) => {
    dispatch(
      CommunicationActions.setCommunicationLoader({
        loading: payload.communicationLoading,
      })
    );
  }
);

export const updateCommunicationPaginatedLoader = createAsyncThunk(
  'updateCommunicationPaginatedLoader',
  async (payload: { paginatedLoading: boolean }, { dispatch }) => {
    dispatch(
      CommunicationActions.setCommunicationPaginatedLoader({
        paginatedLoading: payload.paginatedLoading,
      })
    );
  }
);

export const fetchCommunications = createAsyncThunk(
  'fetchCommunications',
  async ({ childInstanceUrl, eymanageNurseryId, page }: { childInstanceUrl: string, eymanageNurseryId: string, page: number }, { dispatch }) => {
    try {
      if (page === 1) {
        await dispatch(CommunicationActions.resetCommunicationState());
        dispatch(updateCommunicationLoader({ communicationLoading: true }));
      } else {
        dispatch(updateCommunicationPaginatedLoader({ paginatedLoading: true }));
      }
      const response = await fetchCommunication(childInstanceUrl, eymanageNurseryId, page);
      const communicationsResponse = response as CommunicationListResponseType;
      if (communicationsResponse) {
        dispatch(
          CommunicationActions.appendCommunications({
            list: communicationsResponse.messages,
            pagination: communicationsResponse.pagination,
          })
        );
      }
    } catch (error) {
      console.log('Error: ', error);
      throw error;
    } finally {
      dispatch(updateCommunicationLoader({ communicationLoading: false }));
      dispatch(updateCommunicationPaginatedLoader({ paginatedLoading: false }));
    }
  }
);
